import { createModulePage } from '../../components/generic/createModulePage';
import { initializeModule } from '../../utils/configInit';
import { emailTemplateConfig } from './emailTemplateConfig';
import { createEmailTemplateValidationSchema } from './emailTemplateValidation';

/**
 * Initialize the EmailTemplate module using generic utilities
 */
const { config: initializedConfig } = initializeModule(
  emailTemplateConfig,
  createEmailTemplateValidationSchema
);

/**
 * Create the EmailTemplatePage using the generic module page factory
 */
const EmailTemplatePage = createModulePage(
  initializedConfig,
  {
    displayName: 'EmailTemplatePage',
    description: 'Email Template Management System - Email templates for approval request notifications'
  }
);

export default EmailTemplatePage;

